import { Header } from "../../elements/header/Header";
import styles from './NotFound.module.css';
const NotFound = () => {
    return (
        <>
            <Header />
            <div className={styles.middleText}>
                <h1>404</h1>
                <h3>Я не знаю что это за ссылка</h3>
            </div>
        </>
    );
};

export default NotFound;